// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DigitalAssetModel from '../../model/digital-asset-model';
import DigitalAssetDTO from '../dto/digital-asset-dto';
import dtoSchema from '../schemas/digital-asset-schema';

export default abstract class DigitalAssetModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DigitalAssetDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.creatorId = data.creatorId;
      this.created = data.created;
      this.modifierId = data.modifierId ?? undefined;
      this.modified = data.modified ?? undefined;
      this.documentId = data.documentId;
      this.name = data.name ?? undefined;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  * @type {int64}
  */
  creatorId?: number;
  /**
  * @type {date-time}
  */
  created?: string;
  /**
  * @type {int64}
  */
  modifierId?: number;
  /**
  * @type {date-time}
  */
  modified?: string;
  /**
  * @type {int64}
  */
  documentId?: number;
  /**
  */
  name?: string;

  static toModel(dto: DeepPartial<DigitalAssetDTO>): DigitalAssetModel;
  static toModel(dto: DeepPartial<DigitalAssetDTO> | undefined | null): DigitalAssetModel | undefined;
  static toModel(dto: DeepPartial<DigitalAssetDTO> | undefined | null): DigitalAssetModel | undefined {
    return dto ? new DigitalAssetModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DigitalAssetModel> | DigitalAssetModel): DigitalAssetDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      creatorId: unwrapped.creatorId,
      created: unwrapped.created,
      modifierId: unwrapped.modifierId,
      modified: unwrapped.modified,
      documentId: unwrapped.documentId,
      name: unwrapped.name,
    } as DigitalAssetDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DigitalAssetModel, can not map to DigitalAssetDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
